import { inject, Injectable } from '@angular/core'

import { KeySubscriber } from '@app/core/key-subscriber'
import type { Group } from '@app/models/interactions/group/incoming'
import type { Notification } from '@app/modules/notifications'
import { MemberService } from '@app/services/member.service'

@Injectable({
  providedIn: 'root',
})
export class NotificationsStore extends KeySubscriber {
  private readonly memberService = inject(MemberService)

  readonly visitMessages$ = this.provide('messages')
  readonly isVisitingMessages$ = this.observeHasSubscribers('messages')

  readonly showCredits$ = this.provide('credits')
  readonly isShowingCredits$ = this.observeHasSubscribers('credits')

  toGroup(notification: Notification): Group {
    switch (notification.note_type) {
      case 'favorite_added': {
        return 'admirers'
      }
      case 'thread_created':
      case 'thread_updated':
      case 'message_photo_sent':
      case 'voice_message_sent': {
        return 'messages'
      }
      case 'profile_viewed': {
        return 'visitors'
      }
      case 'photo_access_requested': {
        return 'pending_requesters'
      }
      case 'photo_access_granted': {
        if (this.memberService.account.benefactor && notification.data?.photo_access_request.status === 'GRANTED') {
          return 'locked_granters'
        }

        return 'unlocked_granters'
      }
      default: {
        throw new Error(`unrecognized group ${notification.note_type}`)
      }
    }
  }
}
